// @flow

import { type ChatBubbleMessage, CHATCHAMP_MESSAGE_TYPE_JAVASCRIPT } from '@chatchamp/chatchamp-types'

import { logger } from '../../../../common'
import {
  MESSAGE_TYPE_CUSTOMER_SUPPORT,
  MESSAGE_TYPE_GOOGLE_ANALYTICS,
  MESSAGE_TYPE_JAVASCRIPT,
  MESSAGE_TYPE_PRODUCTS,
  MESSAGE_TYPE_STARTED
} from '../../../../common/iframeMessageTypes'
import { executeJavascript } from '../../../../common/javascript'
import { productIds } from '../../../../common/models/Product'

import { postMessageToParent } from '../../../utils/iframe'

import type { MessagesState } from './state'

/** @returns delay in s when the new message should be added */
export function processNewMessage ({ state }: { state: MessagesState }, newMessage: ChatBubbleMessage<any>): number {
  if (newMessage.content?.chatbotStarted === true) {
    postMessageToParent({
      event: MESSAGE_TYPE_STARTED,
      chatbotId: newMessage.content.chatbotId
    })
  }

  if (newMessage.type === CHATCHAMP_MESSAGE_TYPE_JAVASCRIPT) {
    logger.info('Received javascript message')
    // We execute our JavaScript in the iframe and in the main frame
    executeJavascript(newMessage.content.javascript)
    postMessageToParent({
      event: MESSAGE_TYPE_JAVASCRIPT,
      javascript: newMessage.content.javascript
    })
  } else if (newMessage.type === 'google_analytics') {
    logger.info('Received google analytics message')
    postMessageToParent({
      event: MESSAGE_TYPE_GOOGLE_ANALYTICS,
      googleAnalytics: newMessage.content.googleAnalytics
    })
  } else if (newMessage.type === 'products') {
    if (newMessage.content.elements) {
      postMessageToParent({
        event: MESSAGE_TYPE_PRODUCTS,
        chatbotId: newMessage.content.chatbotId,
        productIds: productIds(newMessage.content.elements),
        products: newMessage.content.elements,
        loadedMoreProducts: state.moreProductsClicked
      })
    }
  } else if (newMessage.type === 'progress_bar') {
    state.progressMessage = newMessage.content.progressMessage
    state.progressPercent = newMessage.content.progressPercent
  } else if (newMessage.type === 'live_chat') {
    if (state.customerSupport) {
      postMessageToParent({ event: MESSAGE_TYPE_CUSTOMER_SUPPORT })
      return 1
    }
  }

  return 0
}
